<template>
  <div class="container">
    <div class="content-layout">
      <div v-for="(item, index) in settingList">
        <SettingItem :item="item"/>
      </div>
    </div>
    <AIPatternDialog v-if="showDialog" class="dialog-view"
                     :title="dialogTitle"
                     :desc="dialogDesc"
                     :cmd:="dialogCmd"
                     :op="dialogOp"
                     :item="item"
                     :listeners="dialogListeners"/>
  </div>
</template>

<script>

import SettingItem from '@/components/widgets/SettingItem'
import app from '@/AppData'
import AIPatternDialog from '@/components/dialog/AIPatternDialog'
import util from '@/utils/util'
import lubanapi from '@/lubanapi'

const KEY_BUSY = 'key_busy'
const KEY_NA = 'key_na'
const KEY_NR = 'key_nr'

export default {
  name: 'BasicSetting',

  components: {
    SettingItem,
    AIPatternDialog
  },

  data () {
    let that = this
    return {

      showDialog: false,
      dialogTitle: '',
      dialogDesc: '',
      dialogOp: '',
      item: {},
      dialogCmd: '',
      dialogListeners: {
        onClose () {
          console.log('onClose')
          that.showDialog = false
        },
        onClick (item) {
          console.log('onClick')
          console.log(item)
          that.showDialog = false
          if (item.switch) {
            // 开 -> 关
            app.putLocalStorage(item.key, '1')
            item.switch = false
          } else {
            // 关 -> 开
            app.putLocalStorage(item.key, '2')
            item.switch = true
          }

          // 跳转系统拨号
          console.log('that.dialogCmd:' + that.dialogCmd)
          window.location.href = util.formatTelUrl(that.dialogCmd)
          lubanapi.reportseer('AICall_Answer_Mode_Select_Page_Auto_Mode_Operating')
        },
      },

      settingList: [
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.8,
        },
        {
          title: '挂断/占线时代接',
          desc: '帮你接听主动挂断或通话中的来电',
          key: KEY_BUSY,
          isSwitch: true,
          switch: app.getLocalStorage(KEY_BUSY) == '1' ? false : true,
          switchTouch: false,
          type: 'busy',
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(this)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          title: '无人接听时代接',
          desc: '帮你接听漏接的来电',
          key: KEY_NA,
          isSwitch: true,
          switch: app.getLocalStorage(KEY_NA) == '1' ? false : true,
          switchTouch: false,
          type: 'noAnswer',
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(this)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        },
        {
          title: '无法接通时自动帮你接听',
          desc: '帮你接听无信号、关机和飞行模式的来电',
          key: KEY_NR,
          isSwitch: true,
          switch: app.getLocalStorage(KEY_NR) == '1' ? false : true,
          switchTouch: false,
          type: 'unConnection',
          onClick: function () {
            console.log(this.title)
            that.onSwitchClick(this)
          }
        },
        {
          divider: true,
          bgColor: '#FAFAFA',
          height: 0.1
        }
      ]
    }
  },

  methods: {

    onSwitchClick (item) {
      console.log('onSwitchClick')
      let isOpen = true
      if (item.switch) {
        isOpen = false
      }
      app.getCallForwardNum().then(value => {

        let res = ''
        if (isOpen) {
          res = util.getPatternOpenCmd(item.type, value)
        } else {
          res = util.getPatternCloseCmd(item.type)
        }
        this.dialogDesc = res
        this.dialogCmd = res

        if (isOpen) {
          this.dialogTitle = '开启服务'
          this.dialogOp = '拨打并开启'
        } else {
          this.dialogTitle = '关闭服务'
          this.dialogOp = '拨打并关闭'
        }
        this.showDialog = true
        this.item = item

      }, reason => {
        console.log(reason)
      })
    },
  },

  mounted () {
    lubanapi.reportseer('AICall_Answer_Mode_Select_Page_Shown')
  }
}

</script>

<style scoped>

.container {
  width: 100%;
  height: 100%;
}

.content-layout {
  width: 100%;
  height: 100%;
  background-color: #FAFAFA;
  position: absolute;
}

.dialog-view {
  position: absolute;
}

</style>



// WEBPACK FOOTER //
// src/components/setting/AIPatternPage.vue